import CellLayout from "./CellLayout";
import Earned from "./Earned";
import Details from "./Details";
import Liquidity from "./Liquidity";
import Multiplier from "./Multiplier";
import FarmTokenInfo from "./FarmTokenInfo";
import FarmTableHarvestAction from "./Actions/HarvestAction";
import AccountNotConnect from "./Actions/AccountNotConnect";
import StakeComponent from "./Actions/StakeComponent";

const FarmTable = {
  CellLayout,
  Earned,
  Details,
  Liquidity,
  Multiplier,
  FarmTokenInfo,
  FarmTableHarvestAction,
  AccountNotConnect,
  StakeComponent,
};

export default FarmTable;
